import { ROUTE_NAME } from '@constants';
const reservation = {
  name: ROUTE_NAME.Reservation,
  path: '/reservation',
  redirect: '/reservation/reservation',
  meta: {
    breadcrumb: true,
    breadcrumbName: '예약서비스',
  },
  children: [
    {
      name: ROUTE_NAME.Reservation,
      path: 'reservation',
      component: () => import('@views/reservation/Reservation.vue'),
      meta: {
        requiresAuth: false,
        breadcrumb: true,
        breadcrumbName: '예약하기',
      },
    },
    {
      name: ROUTE_NAME.ReservationModify,
      path: 'reservation-modify',
      component: () => import('@views/reservation/ReservationModify.vue'),
      meta: {
        requiresAuth: false,
        breadcrumb: true,
        breadcrumbName: '예약변경하기',
      },
    },
    {
      name: ROUTE_NAME.ReservationFormModify,
      path: 'reservation-form-modify',
      component: () => import('@views/reservation/ReservationFormModify.vue'),
      meta: {
        requiresAuth: false,
        breadcrumb: true,
        breadcrumbName: '예약변경하기',
      },
    },
    {
      name: ROUTE_NAME.ReservationInformation,
      path: 'information',
      component: () => import('@views/reservation/ReservationInformation.vue'),
      meta: {
        requiresAuth: false,
        breadcrumb: true,
        breadcrumbName: '예약안내',
      },
    },
    {
      name: ROUTE_NAME.ReservationStatus,
      path: 'status',
      component: () => import('@views/reservation/ReservationStatus.vue'),
      meta: {
        requiresAuth: false,
        breadcrumb: true,
        breadcrumbName: '예약확인',
      },
    },
  ],
};

export default reservation;
